import { PATH_REPORTS } from 'snq/helpers/path';

export const PATH_REPORTS_DASHBOARD = `${PATH_REPORTS}/dashboard`;
export const PATH_REPORTS_DASHBOARD_ALTERNATIVE = `${PATH_REPORTS}/dashboard-aternative`;
